import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-logo">
        <img src="/icon.png" alt="Beep" />
        <span className="footer-logo-name">Beep</span>
      </div>
      <p className="footer-copy">© 2026 Amaro · beep.amaro.dev</p>
      <a href="https://amaro.dev" className="footer-link">amaro.dev →</a>
    </footer>
  );
}

export default Footer;
